import { render, staticRenderFns } from "./AgregarButton2.vue?vue&type=template&id=1958ecff&scoped=true&"
import script from "./AgregarButton2.vue?vue&type=script&lang=ts&"
export * from "./AgregarButton2.vue?vue&type=script&lang=ts&"
import style0 from "./AgregarButton2.vue?vue&type=style&index=0&id=1958ecff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1958ecff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1958ecff', component.options)
    } else {
      api.reload('1958ecff', component.options)
    }
    module.hot.accept("./AgregarButton2.vue?vue&type=template&id=1958ecff&scoped=true&", function () {
      api.rerender('1958ecff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/AgregarButton2.vue"
export default component.exports